<script>
  import BusinessUpdatesListItem from "./BusinessUpdatesListItem.svelte";
  import { updates } from "../stores.js";

  export let edit = false;
</script>

<div>
  {#each $updates as update, index}
    <BusinessUpdatesListItem {update} {edit} {index} />
  {/each}
</div>
